import styles from './fallbackLoader.module.scss';

const FallbackLoaderComponent = () => {
    return <div className={styles.loader_line}></div>;
};

export default FallbackLoaderComponent;
